export const TASKS_LIST_VIEW = "/tasks"
export const NEW_TASK_VIEW = TASKS_LIST_VIEW + "/new"
